/**
 * Sign out of Cognito and redirect to the logout page, which will sign out of NextAuth.
 */
export const fullSignOut = async () => {
  const cognitoLogoutUrl = new URL(
    "https://karl-farm.auth.eu-central-1.amazoncognito.com/logout"
  );
  cognitoLogoutUrl.searchParams.append(
    "client_id",
    "6deokvlulcbuuo2rd3dmdfaao5"
  );
  cognitoLogoutUrl.searchParams.append("response_type", "code");
  cognitoLogoutUrl.searchParams.append("scope", "email openid profile");
  cognitoLogoutUrl.searchParams.append("logout_uri", `${window.origin}/logout`); // Note `logout_uri` is used instead of `redirect_uri`. Read more here: https://docs.aws.amazon.com/cognito/latest/developerguide/logout-endpoint.html
  window.location.href = cognitoLogoutUrl.href;
};
